import { authedApiFetch } from 'utils/Api';

const salesforceEntitiesService = {
	getEntities: async (limit = 3) => {
		const response = await authedApiFetch({
			endpoint: `/salesforce_entities?limit=${limit}`,
			method: 'GET',
		});
		return response;
	},
};

export default salesforceEntitiesService;
